import errorParser from '@/utils/error-parser'
import RestResourceService from "@/services/RestResourcesService";

function initialState() {
    return {
        dataChart: {
            DataSearch: [],
            ChartxLabel: '',
            ChartyLabel: '',
            ChartName: '',
            maxLabels: 20,
            IdChart:''
        },
        searchInputValue: '*',
        inputValue: {
            value:'Past 1 Month',
            icon:'1mo',
        },
        codes: [],
        chartLoading: false,
    }
}

export default {
    state: initialState(),
    getters: {
        DASHBOARD_BETA_SEARCH_CODES: state => state.codes,
        DATA_CHART: state => state.dataChart,
        INPUT_VALUE: state => state.inputValue,
        SEARCH_INPUT_VALUE: state => state.searchInputValue,
        PROGRESS_LOADING: state => state.chartLoading,
    },
    mutations: {
        SET_DASHBOARD_SEARCH_CODES(state, payload) {
            state.codes = payload
        }, 
        SET_INPUT_VALUE(state, value) {
            state.inputValue.value = value.suggest;
            state.inputValue.icon = value.icon;
        },
        SET_SEARCH_INPUT_VALUE(state, value) {
            state.searchInputValue = value;
        },
        SET_DATA_CHART(state, payload) {
            if(!payload.data){
                payload.facets.forEach(item => {
                    if(item.type=='date_histogram'){
                        state.dataChart.DataSearch = item.values;
                        state.dataChart.ChartxLabel = item.properties?.xLabel ?? '';
                        state.dataChart.ChartyLabel = item.properties?.yLabel ?? '';
                        state.dataChart.ChartName = item.properties?.title ?? '';
                        state.dataChart.maxLabels = item.properties?.maxLabels ?? 20;
                        state.dataChart.IdChart = 'inspectChart'; 
                    }
                });
            }else{
                state.dataChart.DataSearch = payload.data.facet.values;
                state.dataChart.ChartxLabel = payload.data.config?.xLabel ?? '';
                state.dataChart.ChartyLabel = payload.data.config?.yLabel ?? '';
                state.dataChart.ChartName = payload.data.config?.title ?? '';
                state.dataChart.maxLabels = payload.data.config?.maxLabels ?? 20; 
                state.dataChart.IdChart = payload.id;
            }
        },
        SET_PROGRESS_LOADING(state, payload) {
            state.chartLoading = payload;
        },
    },
    actions: {
        GET_DASHBOARD_BETA_SEARCH_CODES: ({commit, dispatch}, payload) => {
            commit('SET_PROGRESS_LOADING', true);
            return RestResourceService.getResources(payload.url)
                .then((response) => {
                    commit('SET_DASHBOARD_SEARCH_CODES', response.data);
                    commit('SET_PROGRESS_LOADING', false);
                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: true,
                    });
                    throw new Error(error);
                })
        },
        UPDATE_INPUT_VALUE({ commit }, newValue) {
            commit('SET_INPUT_VALUE', newValue);
        },
        UPDATE_SEARCH_INPUT_VALUE({ commit }, newValue) {
            commit('SET_SEARCH_INPUT_VALUE', newValue);
        },
        GET_DATA_CHART: ({commit, dispatch}, payload) => {
            commit('SET_PROGRESS_LOADING', true);
            return RestResourceService.postResources(payload.url, payload.searchQuery)
                .then((response) => {
                    if(payload.accessorPath){
                        commit('SET_DATA_CHART', response.data.result?.[payload.accessorPath] );
                    }else{
                        commit('SET_DATA_CHART', response.data );
                    }
                    commit('SET_PROGRESS_LOADING', false);
                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: true,
                    });
                    throw new Error(error);
                })
        },
    }
}
